import { Icons } from '@Assets/SvgIcons';
import React, { useEffect, useState } from 'react';
import css from './AiModal.module.css';
import { Icon, Modal } from '@mui/material';
import GeneralTab, { MessageHolder } from './TabContent/GeneralTab';
import DocumentTab from './TabContent/DocumentTab';
import WorkplanTab from './TabContent/WorkplanTab';
import KnowledgebaseTab, { AskListType } from './TabContent/KnowledgebaseTab';
import {
  AiHistoryModel,
  DealspaceSubscription,
  SubscriptionType,
} from '@Helper/Interfaces';
import {
  deleteAiHistory,
  getAiHistory,
  postAiHistory,
} from '@Store/feature/aiHistorySlice';
import { useAppDispatch, useAppSelector } from '@Store/hooks';
import HistoryBox from './TabContent/HistoryBox';
import { ComponentHelper } from '@Helper/Infra';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getUserDealspaceList } from '@Store/feature/dealspaceSlice';
import moment from 'moment';

type TabListType = {
  name: string;
  content: React.ReactNode;
};

type HistoryTabListType = {
  value: string;
  name: string;
};

type AiProps = {
  openAiProps: boolean;
  fromLayout: boolean;
  selectedAiModal?: AiHistoryModel;
  setShowModalFromLayout?: (show: boolean) => void;
  setTrayAiHistory?: (show: AiHistoryModel | undefined) => void;
  setOpenLayout?: (show: boolean) => void;
};

export type TabProps = {
  initialMessageHolder: MessageHolder[];
  currentConversationId: string;
  historyMode: boolean;
  setMainMessageHolder?: (messageHolder: MessageHolder[]) => void;
  setMainConversationId?: (convId: string) => void;
  setAskMainType?: (askMain: AskListType | null) => void;
  askMain?: AskListType;
};

const AiModal = ({
  openAiProps,
  selectedAiModal,
  setTrayAiHistory,
  fromLayout,
  setShowModalFromLayout,
  setOpenLayout,
}: AiProps) => {
  const { aiHistory } = useAppSelector(getAiHistory);
  const [mainConversationId, setMainConversationId] = useState(
    selectedAiModal?.conversationId ?? ''
  );
  const { id } = useParams();
  const [mainMessageHolder, setMainMessageHolder] = useState<MessageHolder[]>(
    selectedAiModal?.messageHolder ?? []
  );
  const componentHelper = new ComponentHelper();

  const [mainAskType, setMainAskType] = useState<AskListType | null>(null);
  const [historyMode, setHistoryMode] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [initialAiModal, setinitialAiModal] = useState<
    AiHistoryModel | undefined
  >(selectedAiModal);

  const tabList = [
    {
      name: 'Knowledgebase',
      content: (
        <KnowledgebaseTab
          initialMessageHolder={mainMessageHolder ?? []}
          currentConversationId={mainConversationId ?? ''}
          setMainConversationId={setMainConversationId}
          setMainMessageHolder={setMainMessageHolder}
          setAskMainType={setMainAskType}
          historyMode={historyMode}
          askMain={
            selectedAiModal?.askListType === null
              ? undefined
              : selectedAiModal?.askListType
          }
        />
      ),
    },
    {
      name: 'Document',
      content: (
        <DocumentTab
          initialMessageHolder={mainMessageHolder ?? []}
          currentConversationId={mainConversationId ?? ''}
          setMainConversationId={setMainConversationId}
          setMainMessageHolder={setMainMessageHolder}
          historyMode={historyMode}
        />
      ),
    },
    {
      name: 'General',
      content: (
        <GeneralTab
          initialMessageHolder={mainMessageHolder ?? []}
          currentConversationId={mainConversationId ?? ''}
          setMainConversationId={setMainConversationId}
          setMainMessageHolder={setMainMessageHolder}
          historyMode={refresh}
        />
      ),
    },
    {
      name: 'Workplan',
      content: '',
    },
  ] as TabListType[];

  const historyTabList = [
    {
      name: 'Knowledge History',
      value: 'knowledge',
    },
    {
      name: 'User Document History',
      value: 'userdocument',
    },
    {
      name: 'General Chat History',
      value: 'generalchat',
    },
  ] as HistoryTabListType[];
  const [open, setOpen] = useState<boolean>(openAiProps);

  const userDealspaceList = useAppSelector(getUserDealspaceList) ?? [];
  const handleOpen = async () => {
    const subscriptionElements = (await componentHelper.getDealspaceSubscribe2(
      id ?? ''
    )) as DealspaceSubscription;
    console.log('subscriptionElements', subscriptionElements);
    if (
      !subscriptionElements?.subscription &&
      userDealspaceList?.find(
        i =>
          i.id === (id ?? '') &&
          (!i.trialEndDate || moment(i.trialEndDate).isSameOrAfter(moment()))
      )?.subscriptionType !== SubscriptionType.TRIAL
    ) {
      toast("You don't have AI Feature in your subscription");
      return;
    }
    if (
      !subscriptionElements?.subscription?.aiEnabled &&
      userDealspaceList?.find(
        i =>
          i.id === (id ?? '') &&
          (!i.trialEndDate || moment(i.trialEndDate).isSameOrAfter(moment()))
      )?.subscriptionType !== SubscriptionType.TRIAL
    ) {
      toast("You don't have AI Feature in your subscription");
      return;
    }

    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    if (setShowModalFromLayout) {
      setShowModalFromLayout(false);
    }
    if (setOpenLayout) {
      setOpenLayout(false);
    }
    setMainConversationId('');
    setMainMessageHolder([]);
    setinitialAiModal(undefined);
  };
  const dispatch = useAppDispatch();

  const [activeTab, setActiveTab] = useState(
    selectedAiModal
      ? tabList.find(i => i.name === selectedAiModal.name) ?? tabList[0]
      : tabList[0]
  );

  const [historyTab, setHistoryTab] = useState<string>('knowledge');
  const goToContent = (id: string, messageHolder: MessageHolder[]) => {
    console.log('messageHolder', messageHolder);

    setMainConversationId(id);
    setMainMessageHolder([...messageHolder]);
    let actTab = '';
    if (historyTab === 'knowledge') {
      actTab = 'Knowledgebase';
    } else if (
      historyTab === 'userdocsummary' ||
      historyTab === 'userdocument'
    ) {
      actTab = 'Document';
    } else {
      actTab = 'General';
    }
    setHistoryMode(false);
    setRefresh(!refresh);
    const actTabVal = tabList.find(i => i.name === actTab);
    if (actTabVal) setActiveTab(actTabVal);
  };

  useEffect(() => {
    setActiveTab(tabList[0]);
  }, [open]);

  useEffect(() => {
    console.log('effect', selectedAiModal);

    if (selectedAiModal) {
      setOpen(openAiProps);
      setinitialAiModal(selectedAiModal);
      console.log(selectedAiModal.name);

      setActiveTab(
        tabList.find(i => i.name === selectedAiModal.name) ?? tabList[0]
      );
      setMainMessageHolder(selectedAiModal.messageHolder);
      setMainConversationId(selectedAiModal.conversationId);
      setMainAskType(selectedAiModal.askListType);
    } else {
      setMainConversationId('');
      setMainAskType(null);
    }
  }, [openAiProps, selectedAiModal, initialAiModal, open]);

  const windowMinimize = () => {
    if (mainMessageHolder.length > 0) {
      if (setOpenLayout) {
        setOpenLayout(false);
      }
      console.log('aiHistory', aiHistory);
      setinitialAiModal(undefined);
      if (aiHistory !== null) {
        const item = aiHistory.find(
          a => a.conversationId === mainConversationId
        );
        if (item) {
          dispatch(deleteAiHistory(mainConversationId));
        }
        dispatch(
          postAiHistory({
            conversationId: mainConversationId,
            messageHolder: mainMessageHolder,
            name: activeTab.name,
            askListType: mainAskType,
          })
        );
      }
    }
    if (aiHistory === null) {
      dispatch(
        postAiHistory({
          conversationId: mainConversationId,
          messageHolder: mainMessageHolder,
          name: activeTab.name,
          askListType: mainAskType,
        })
      );
    }

    setOpen(false);
    if (setShowModalFromLayout) {
      setShowModalFromLayout(false);
    }
  };

  return (
    <div>
      {!fromLayout && (
        <button
          id="askAiButton"
          className={css.askAiButton}
          onClick={handleOpen}
        >
          <Icons.Undo />
          <span>Ask AI</span>
        </button>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ minWidth: '90vh' }}
      >
        <div className={css.aiModalContainer}>
          <div className={css.aiModalHeader}>
            <div className={css.aiModalHeaderLeft}>
              <button
                className={css.askAiButton}
                onClick={() => {
                  setHistoryMode(false);
                }}
              >
                <Icons.Undo />
                <span>Ask AI</span>
              </button>
            </div>
            <div className={css.aiModalHeaderRight}>
              <button
                className={css.aiNewBtn}
                onClick={evt => {
                  setOpen(false);
                  setTimeout(() => {
                    if (setTrayAiHistory) {
                      setTrayAiHistory(undefined);
                    }
                    setOpen(true);
                    if (historyMode) {
                      setHistoryMode(false);
                    }
                    setActiveTab(activeTab);
                    setMainAskType(null);
                    setMainConversationId('');
                    setMainMessageHolder([]);
                  }, 100);
                }}
              >
                <Icons.Add color="#30259B" width="16px" height="16px" />
                <span>New session</span>
              </button>
              <button
                className={css.actionAiBtn}
                onClick={() => {
                  console.log('clicked');
                  setHistoryMode(true);
                }}
              >
                <Icons.History color="#615E84" width="20" height="20" />
              </button>

              <button className={css.actionAiBtn} onClick={windowMinimize}>
                <Icons.WindowMinimize color="#615E84" width="20" height="20" />
              </button>
              <button
                className={css.actionAiBtn}
                onClick={handleClose}
                id="closeAi"
              >
                <Icons.Cancel width="20" height="20" />
              </button>
            </div>
          </div>
          {historyMode && (
            <div
              className={[
                css.fitContent,
                'customScroll',
                'aiHistoryContent',
              ].join(' ')}
            >
              <div className="aiHistoryContent-close">
                <button onClick={() => setHistoryMode(false)}>
                  <Icons.Cancel width="20" height="25" />
                </button>
              </div>
              <div className={css.aiModalTabBtnContent}>
                {historyTabList?.map((item, index) => (
                  <button
                    className={[
                      css.TabBtn,
                      historyTab === item.value && css.activeTab,
                    ].join(' ')}
                    key={index}
                    onClick={() => {
                      if (setTrayAiHistory) {
                        setTrayAiHistory(undefined);
                      }
                      setMainAskType(null);
                      setMainConversationId('');
                      setMainMessageHolder([]);
                      setHistoryTab(item.value);
                    }}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
              <HistoryBox historyType={historyTab} goToContent={goToContent} />
            </div>
          )}

          <>
            <div className={css.aiModalTabBtnContent}>
              {tabList?.map((item, index) => (
                <button
                  className={[
                    css.TabBtn,
                    activeTab.name === item.name && css.activeTab,
                  ].join(' ')}
                  id={'tab' + item.name}
                  key={index}
                  onClick={() => {
                    if (setTrayAiHistory) {
                      setTrayAiHistory(undefined);
                    }
                    setMainAskType(null);
                    setMainConversationId('');
                    setMainMessageHolder([]);
                    setActiveTab(item);
                  }}
                >
                  {item.name}
                </button>
              ))}
            </div>
            {activeTab.name === 'General' && (
              <GeneralTab
                initialMessageHolder={mainMessageHolder ?? []}
                currentConversationId={mainConversationId ?? ''}
                setMainConversationId={setMainConversationId}
                setMainMessageHolder={setMainMessageHolder}
                historyMode={historyMode}
              />
            )}
            {activeTab.name === 'Document' && (
              <DocumentTab
                initialMessageHolder={mainMessageHolder ?? []}
                currentConversationId={mainConversationId ?? ''}
                setMainConversationId={setMainConversationId}
                setMainMessageHolder={setMainMessageHolder}
                historyMode={historyMode}
              />
            )}
            {activeTab.name === 'Knowledgebase' && (
              <KnowledgebaseTab
                initialMessageHolder={mainMessageHolder ?? []}
                currentConversationId={mainConversationId ?? ''}
                setMainConversationId={setMainConversationId}
                setMainMessageHolder={setMainMessageHolder}
                setAskMainType={setMainAskType}
                historyMode={historyMode}
                askMain={
                  selectedAiModal?.askListType === null
                    ? undefined
                    : selectedAiModal?.askListType
                }
              />
            )}
            {activeTab.name === 'Workplan' && (
              <WorkplanTab
                initialMessageHolder={mainMessageHolder ?? []}
                currentConversationId={mainConversationId ?? ''}
                setMainConversationId={setMainConversationId}
                setMainMessageHolder={setMainMessageHolder}
                historyMode={historyMode}
              />
            )}
          </>
        </div>
      </Modal>
    </div>
  );
};

export default AiModal;
